module.exports = __webpack_public_path__ + "static/img/product-wireless.9ed2e9c6.png";